<template>
  <div>
    <div class="back" @click="back">
      <i></i>
      <span>返回</span>
    </div>

    <el-card>
      <h2>试卷加密设置</h2>
      <div class="main_box">
        <!-- 左边重要提示部分 -->
        <div class="main_left">
          <div class="marked">
            <h3>【重要提示】</h3>
            <div class="marked_son">
              <p>
                1、设置试卷独立密码后，可以对试卷进行加密操作，已加密试卷需要解密后才可进行操作；
              </p>
              <p>
                2、在“试题管理”中开启试题保护后，试题管理内的自主试题需验证独立密码后才可使用；
              </p>
              <p style="color: #ff4747">
                3、由于加密的不可逆，若遗忘独立密码，所加密的试卷/试题将不能恢复(只能删除)，请务必牢记独立密码。
              </p>
            </div>
          </div>

          <div class="marked">
            <h3>【“试卷加密”功能有什么用？】</h3>
            <div class="marked_son">
              <p>
                1、虽然考核云登录密码可以保证您的信息安全，但对于试卷绝密性质，“试卷加密”更有针对性。
              </p>
              <p>“试卷加密”功能主要作用包括：</p>
              <p>(1)、通过加密试卷，给用于考试的试卷进行二次保护。</p>
              <p>
                (2)、万一账号登录密码被盗，盗号者只能会看到您的试卷列表，不能看到试卷的试题内容。如果您非常担心试卷泄题，
                那么可以使用“试卷加密”功能来保护试卷。
              </p>
            </div>
          </div>

          <div class="marked">
            <h3>【“试卷加密”功能也有不利的一面】</h3>
            <div class="marked_son">
              <p>
                1、在进行试卷修改的时候，需要先解密试卷才可以进行操作，这可能为您带来一定程度的繁琐。因此您可以权衡您的
                需要，来决定是否使用“试卷加密”功能。
              </p>
            </div>
          </div>
        </div>
        <!-- 设置独立密码部分 -->
        <div class="mian_right">
          <h3>设置独立密码</h3>
          <el-form
            :model="loginForm"
            status-icon
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <div class="password_box">
              <div class="password_input">
                <el-form-item label="登录密码：" prop="account">
                  <el-input
                    placeholder="请输入考核云密码"
                    v-model.trim="loginForm.account"
                    :type="flag ? 'password' : 'text'"
                    autocomplete="off"
                    maxlength="20"
                  >
                    <template>
                      <i
                        slot="suffix"
                        class="iconfont"
                        :class="flag ? 'icon-yincangmima' : 'icon-eyes'"
                        @click="flag = !flag"
                      ></i>
                    </template>
                  </el-input>
                  <span class="isError" v-if="isError">密码错误</span>
                </el-form-item>
              </div>
              <div class="password_input">
                <div>
                  <el-form-item label="新独立密码：" prop="password">
                    <el-input
                      placeholder="请输入新密码"
                      v-model.trim="loginForm.password"
                      :type="flag1 ? 'password' : 'text'"
                      autocomplete="off"
                    >
                      <template>
                        <i
                          slot="suffix"
                          class="iconfont"
                          :class="flag1 ? 'icon-yincangmima' : 'icon-eyes'"
                          @click="flag1 = !flag1"
                        ></i> </template
                    ></el-input>
                  </el-form-item>
                  <p>6-20位，支持英文数字符号</p>
                </div>
              </div>

              <div class="password_input">
                <el-form-item label="再次输入：" prop="confirmPassword">
                  <el-input
                    placeholder="请再次输入密码"
                    v-model.trim="loginForm.confirmPassword"
                    :type="flag2 ? 'password' : 'text'"
                    autocomplete="off"
                  >
                    <template>
                      <i
                        slot="suffix"
                        class="iconfont"
                        :class="flag2 ? 'icon-yincangmima' : 'icon-eyes'"
                        @click="flag2 = !flag2"
                      ></i> </template
                  ></el-input>
                </el-form-item>
              </div>
            </div>
          </el-form>
        </div>
      </div>
      <!-- 按钮操作 -->
      <div class="operation">
        <el-button type="primary" @click="resetForm('ruleForm')" size="mini"
          >暂不设置</el-button
        >
        <el-button size="mini" @click="submitForm('ruleForm')">保存</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { checkAge, validatePass, validatePass2 } from "@/utils/validata";
import loginvuex from "@/store/index";
import { setCryptoPwd } from "@/api/examination.js";
import md5 from "js-md5";
export default {
  data() {
    return {
      isHavePwd: "", // 为1的时候设置了独立密码，为0反之
      input: "",
      loginForm: {
        account: "",
        password: "",
        confirmPassword: "",
      },
      isError: false, // 密码错误提示框
      // 规则控制 - 规则字段一定要和数据的字段保持一致
      rules: {
        account: [{ validator: checkAge, trigger: "blur" }],
        password: [{ validator: validatePass(this), trigger: "blur" }],
        confirmPassword: [{ validator: validatePass2(this), trigger: "blur" }],
      },
      flag: true, // input查看隐藏密码的矢量图
      flag1: true,
      flag2: true,
    };
  },
  props: ["cutcoms"],
  methods: {
    back() {
      // this.$parent.cutcoms(0); // 返回上一级
      this.$router.push("/papers");
    },

    submitForm(ruleForm) {
      // 确定校验
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          this.setIndepenPwd(); //设置密码校验通过

          // this.verifyPwd(); //独立密码校验通过
        } else {
          console.log("通过失败");
          // this.deleteVisible = true;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields(); // 重置
      // this.$parent.$children.getDatalist();
      // this.$parent.getDatalist();
      // this.cutcoms(0);
      this.$router.push("/papers");
      console.log(513);
    },
    // 设置独立密码
    async setIndepenPwd() {
      let params = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        userPwd: md5(this.loginForm.account), // 考核云密码
        cryptoPwd: md5(this.loginForm.confirmPassword), // 设置的新密码
      };
      const Data = await setCryptoPwd(params);
      if (Data.data.Status === 200) {
        this.$message({
          message: "独立密码保存成功",
          type: "success",
        });
        // this.cutcoms(0); // 去IndepenPwa
        setTimeout(() => {
          this.$router.push("/user_center/modifyThe"); // 去到修改密码地方
        }, 2000);
        // this.$router.go(0); // 强制刷新一遍
      } else {
        this.isError = true;
        this.$message.error("请求失败");
      }

      console.log(Data, "设置成功了");
      console.log(Data.data.Status, "密码错了了");
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.back {
  border-bottom: 1px solid #f8f8f8;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  border-radius: 0 0 10px 10px;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    //  background-color: aqua;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
::v-deep .el-card__body {
  padding: 0;
}
.el-card {
  margin-top: 24px;
  border-radius: 10px;
  padding: 0;
  height: 1000px;
  h2 {
    height: 60px;
    background: #d8edff;
    opacity: 1;
    border-radius: 10px 10px 0px 0px;
    padding: 16px 24px;
    font-size: 20px;
  }
  .main_box {
    padding: 30px 24px;
    position: relative;
    .main_left {
      .marked {
        h3 {
          margin-bottom: 30px;
        }
        .marked_son {
          margin-bottom: 50px;
          p {
            line-height: 35px;
            font-size: 15px;
            font-family: PingFang SC;
            font-weight: 400;
            width: 784px;
          }
        }
      }
    }
    .mian_right {
      width: 610px;
      height: 414px;
      border-radius: 10px;
      box-sizing: border-box;
      //   border: 1px solid red;
      position: absolute;
      right: 30px;
      top: 30px;
      box-shadow: 0px 3px 15px #d8edff;
      h3 {
        width: 610px;
        height: 58px;
        background: #1890ff;
        opacity: 1;
        border-radius: 10px 10px 0px 0px;
        color: #ffffff;
        text-align: center;
        line-height: 58px;
        font-size: 18px;
        letter-spacing: 2px;
      }
      .password_box {
        padding: 40px 30px 60px 30px;
        .password_input {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          p {
            width: 120px;
            height: 24px;
          }

          > div {
            p {
              width: 100% !important;
              margin-left: 102px;
              font-size: 13px;
            }
          }
          ::v-deep .el-input--suffix .el-input__inner {
            width: 450px;
            height: 56px !important;
          }
        }
      }
    }
  }
  .operation {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 50px;
    .el-button {
      width: 162px;
      height: 50px;
    }
    .el-button:nth-child(2) {
      margin-left: 50px;
      background: #0fc758;
      color: #ffffff;
    }
  }
}
::v-deep .el-input__suffix {
  // top: 2px !important;
  // right: 15px !important;
  .el-input__suffix-inner > i {
    font-size: 22px;
  }
}
.isError {
  color: red;
  position: absolute;
  left: 0;
  top: 51px;
}
</style>